// import '@aws-amplify/ui-react/styles.css';
import React, { useState, useEffect } from 'react';
import { API, Storage } from 'aws-amplify';
import { listUserProfiles } from '../../graphql/queries';
import Avatar from '@mui/material/Avatar';
import { fetchUserProfiles } from '../shared/fetchProfiles';

import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';

import {
  View,
  Flex,
  Heading,
  Card,
  Badge,
  Text,
  useTheme,
} from '@aws-amplify/ui-react';

export const RacerProfiles = () => {
  const [userProfiles, setUserProfile] = useState([]);

  useEffect(() => {
    async function wrapper() {
      setUserProfile(await fetchUserProfiles());
    }
    wrapper();
  }, []);

  const { tokens } = useTheme();

  const MyCard = (props) => (
    <View
      backgroundColor={tokens.colors.background.secondary}
      padding={tokens.space.medium}
      width="450px"
    >
      <Card
        borderRadius="medium"
        maxWidth="60rem"
        // height="370px"
        variation="outlined"
      >
        <Flex direction="row" alignItems="flex-start">
          <Avatar
            alt={props.racerdeets?.name}
            src={props.racerdeets?.profileImage}
            sx={{ width: 200, height: 200 }}
          ></Avatar>
          <Flex
            direction="column"
            alignItems="flex-start"
            gap={tokens.space.xs}
          >
            <Heading level={5}>{props.name}</Heading>
            {/* <Text as="div">
              Team:
              {props.racerdeets.groups[0]
                ? props.racerdeets.groups[0]
                : 'no team'}
            </Text> */}
            <Text as="span">{props.racerdeets.sponsor}</Text>
            <Text as="span">2001 Mazda Miata</Text>
            <Flex>
              <Badge size="small" variation="info">
                SMT
              </Badge>
              <Badge size="small" variation="success">
                ITA
              </Badge>
            </Flex>
            <Link to={`/telemetry-stream/${props.racerdeets.username}`}>
              {/* {() => console.log(props.racerdeets)} */}
              Live Stream
            </Link>
          </Flex>
        </Flex>
      </Card>
    </View>
  );

  return (
    <View
      textAlign="center"
      // borderRadius="6px"
      // border="4px solid black"
      // width="800px"
    >
      <Heading level={1}>Racer Profiles</Heading>
      <Flex
        justifyContent="center"
        direction="row"
        wrap="wrap"
        alignItems="center"
      >
        {userProfiles.map((userProfile) => (
          <MyCard
            key={userProfile.id}
            name={userProfile.name}
            racerdeets={userProfile}
          ></MyCard>
        ))}
      </Flex>
    </View>
  );
};
